// import PropTypes from 'prop-types';
import styles from './ReleaseImageCard.module.scss';
import Image from '../Image/Image';
import classNames from 'classnames';
import { ucFirst } from '../../utils/caseconverters';
import YouTubeVideo from '../YouTubeVideo';

const ReleaseImageCard = ({
    video = {},
    modifiers = [],
    title,
    description,
    isHighlighted = false,
}) => {
    const classes = classNames(
        styles['ReleaseImageCard'],
        modifiers.map(
            (modifier) => styles['ReleaseImageCard--' + ucFirst(modifier)] + ' '
        ),
        {
            [styles['ReleaseImageCard--Highlighted']]: isHighlighted,
        }
    );

    return (
        <div className={classes}>
            <div className={styles['ReleaseImageCard__Container']}>
                <div className={styles['ReleaseImageCard__Video']}>
                    <YouTubeVideo videoId={video.videoId} title={video.title} />
                </div>

                <div className={styles['ReleaseImageCard__Content']}>
                    <h3 className={styles['ReleaseImageCard__Title']}>
                        {title}
                    </h3>
                    <p className={styles['ReleaseImageCard__Description']}>
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
};

ReleaseImageCard.propTypes = {};

export default ReleaseImageCard;
